import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const IssueTypeDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			leftContent={
				<Link
					from="/$organizationId/$projectId/issue-types/$issueTypeId"
					to="/$organizationId/$projectId/issue-types"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Issues
					</Button>
				</Link>
			}
		/>
	)
})
IssueTypeDetailViewTopBar.displayName = "IssueTypeDetailViewTopBar"
